exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".place-order-button--checkout{width:max-content;margin:0 auto}.place-order-button--button-text{display:flex;justify-content:center}.place-order-button--button-text--light{font-weight:normal}", ""]);

// exports
